<template>
  <PreviewHistoryProcessModel :canEdit="canEdit" @close="close" ref="previewHistoryDialog"/>
</template>

<script>
import historyService from "./history-service";
import PreviewProcessModelDialog from '@/components/PreviewProcessModelDialog.vue';
import PreviewHistoryProcessModel from './PreviewHistoryProcessModel.vue';

export default {
  components: { PreviewHistoryProcessModel },
  props: {
    uuid: String,
    fileName: String,
    canEdit: Boolean
  },
  data: function() {
    return {
      history: [],
    };
  },
  mounted: function() {
    if (this.uuid) {
      this.retrieveHistory();
    }
  },
  watch: {
    commit: function(val) {
      if (val) {
        this.retrieveHistory();
      }
    },
  },
  methods: {
    retrieveHistory() {
      historyService.retrieveHistory(this.uuid).then((result) => {
        this.history = result.data;
        this.history.forEach(elem => {
          historyService
          .getHistoryProcessXml(
            this.uuid,
            elem.commitHash
          )
          .then(result => {
            elem.processXML = result.data;
          });
        })
        this.$refs.previewHistoryDialog.open(
          this.history,
          "Historie von "+this.fileName,
          "Auswählen"
        ).then(item => {
          historyService.revertToHistoryVersion(
            this.uuid,
            item.commitHash
          ).then(()=>this.$emit("changed"));
        })
      });
    },
    openDialog(item) {
      this.selectedItem = item;
      this.showHistoryProcessDialog = true;
    },
    processChanged(){
      this.retrieveHistory();
      this.$emit("changed");
    },
    close(){
      this.$emit('closeHistory');
    }
  },
};
</script>
<style scoped>
.box {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  overflow-y: auto;
}
</style>
